module.exports = __webpack_public_path__ + "static/media/mobileScreenshot02.2d87ab87.jpg";